/**
 * Focus-directive, fokusoi elementin kun direktiivin attribuutin lauseke palauttaa truen.
 */
app.directive('focusMe', ["$timeout", "$parse", function($timeout, $parse) {
	return {
		link: function(scope, element, attrs) {
			var focus = $parse(attrs.focusMe);
			scope.$watch(focus, function(value) {
				if(value) {
					$timeout(function() {
						element[0].focus();
					});
				}
			});
		}
	};
}]);